import { render, staticRenderFns } from "./temhead6.vue?vue&type=template&id=53248d9d&scoped=true"
import script from "./temhead6.vue?vue&type=script&lang=js"
export * from "./temhead6.vue?vue&type=script&lang=js"
import style0 from "./temhead6.vue?vue&type=style&index=0&id=53248d9d&prod&lang=scss&scoped=true"
import style1 from "./temhead6.vue?vue&type=style&index=1&id=53248d9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53248d9d",
  null
  
)

export default component.exports